import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Items } from '../../providers/providers';

/**
 * Generated class for the RedirectPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'redirect',
  segment: 'redirect/:id',
})
@Component({
  selector: 'page-redirect',
  templateUrl: 'redirect.html',
})
export class RedirectPage {

  assessmentsArray = [];
  clientName: string;
  clientId: string;
  isSchedule: boolean;
  isEmailResultToClient: string
  reportsArray : Array<{report_url : string , assessmentName : string}> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public items: Items) {
    if (this.navParams.get('id') != undefined) {
      this.items.getAssessmentForSchedule(this.navParams.get('id')).subscribe(
        data => {
          if (data) {
            this.assessmentsArray = data.schedule.assessments;
            this.isSchedule = true;
            this.isEmailResultToClient = data.schedule.client_email_results
          }
          this.navCtrl.push('administer', { assessments: this.assessmentsArray, uId: this.navParams.get('id'), isSchedule: true, index: 0, isEmailResultToClient: this.isEmailResultToClient, reports: this.reportsArray });
        },
        err => {
          console.log(err);
        },
      );
    }
  }

  ionViewDidLoad() {
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/redirect/redirect.ts